import * as Yup from 'yup';

export const UpdatePriceSchema = Yup.object().shape({
  price: Yup.string().min(1).required('Price is required'),
});

export type UpdatePriceDataType = Yup.InferType<typeof UpdatePriceSchema>;

type InitialValues = {
  price: string;
};

export const UpdatePriceInitialValues: InitialValues = {
  price: '',
};

export interface IUpdatePriceResponse {
  id: string;
  warehouseId: string;
  amount: number;
  areaId: number;
  areaName: string;
  createdBy: string;
  createdDate: string;
}

export interface IUpdatePriceRequest {
  priceId: string;
  price: string;
}
